module.exports = __webpack_public_path__ + "assets/img/Rules_tit.10c2f961.png";